(() => {
  const gmailSpamUrl = 'https://mail.google.com/mail/u/0/#spam';
  const popupSessionKey = 'belvia-popup-shown-this-session-v2';
  const closeSelector =
    'button[aria-label*="close" i], button[aria-label*="cerrar" i], button[class*="close" i], [role="button"][aria-label*="close" i], [role="button"][aria-label*="cerrar" i]';

  const findPopupContext = (component) => {
    let container = component;

    for (let depth = 0; depth < 8 && container && container !== document.body; depth += 1) {
      const closeButton = container.querySelector(closeSelector);
      if (closeButton) return { container, closeButton };
      container = container.parentElement;
    }

    return null;
  };

  const isVisible = (element) => {
    if (!element || element.getClientRects().length === 0) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  };

  let popupAlreadyShown = false;

  try {
    popupAlreadyShown = sessionStorage.getItem(popupSessionKey) === 'true';
  } catch (error) {
    popupAlreadyShown = false;
  }

  if (popupAlreadyShown) {
    const closeRepeatedPopup = () => {
      document.querySelectorAll('.chp_component').forEach((component) => {
        const context = findPopupContext(component);
        if (!context || context.container.dataset.belviaAutoClosed === 'true') return;
        if (!isVisible(context.container) || !isVisible(context.closeButton)) return;

        context.container.dataset.belviaAutoClosed = 'true';
        context.closeButton.click();
      });
    };

    closeRepeatedPopup();
    new MutationObserver(closeRepeatedPopup).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
    });
  } else {
    const rememberVisiblePopup = () => {
      const component = document.querySelector('.chp_component');
      if (!component) return false;

      const context = findPopupContext(component);
      if (!context || !isVisible(context.container)) return false;

      try {
        sessionStorage.setItem(popupSessionKey, 'true');
      } catch (error) {
        return true;
      }

      return true;
    };

    if (!rememberVisiblePopup()) {
      const firstPopupObserver = new MutationObserver(() => {
        if (!rememberVisiblePopup()) return;
        firstPopupObserver.disconnect();
      });

      firstPopupObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden'],
      });
    }
  }

  const normalize = (value) =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  const isSpamLabel = (element) => {
    const label = normalize(element.textContent || '');
    return label === 'revisa spam' || label === 'revisar spam';
  };

  const makeGmailSpamLink = (element) => {
    if (!isSpamLabel(element) || element.children.length > 0) return;

    if (element instanceof HTMLAnchorElement) {
      element.href = gmailSpamUrl;
      element.target = '_self';
      element.rel = 'noopener noreferrer';
      element.dataset.belviaSpamLink = 'true';
      element.setAttribute('aria-label', 'Abrir Gmail en la carpeta de spam');
      element.style.setProperty('pointer-events', 'auto', 'important');
      element.style.setProperty('cursor', 'pointer', 'important');
      return;
    }

    const link = document.createElement('a');
    link.href = gmailSpamUrl;
    link.target = '_self';
    link.rel = 'noopener noreferrer';
    link.dataset.belviaSpamLink = 'true';
    link.setAttribute('aria-label', 'Abrir Gmail en la carpeta de spam');
    link.textContent = element.textContent;
    link.className = element.className;
    link.style.cssText = element.style.cssText;
    link.style.display = 'inline-block';
    link.style.cursor = 'pointer';
    link.style.color = 'inherit';
    link.style.textDecoration = 'underline';
    link.style.textUnderlineOffset = '3px';
    link.style.setProperty('pointer-events', 'auto', 'important');
    link.style.setProperty('position', 'relative', 'important');
    link.style.setProperty('z-index', '2147483647', 'important');

    element.replaceWith(link);
  };

  const openSpam = (event) => {
    const link = event.target.closest('[data-belvia-spam-link="true"]');
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.assign(gmailSpamUrl);
  };

  const prepareSpamLinks = (root = document) => {
    root
      .querySelectorAll(
        '.chp_component div, .chp_component span, .chp_component a, .chp_component button, [data-belvia-spam-link]'
      )
      .forEach(makeGmailSpamLink);
  };

  prepareSpamLinks();
  document.addEventListener('click', openSpam, true);
  new MutationObserver(() => prepareSpamLinks()).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
